import { render, staticRenderFns } from "./TherapistView.vue?vue&type=template&id=2cfdd452&scoped=true"
import script from "./TherapistView.vue?vue&type=script&lang=js"
export * from "./TherapistView.vue?vue&type=script&lang=js"
import style0 from "./TherapistView.vue?vue&type=style&index=0&id=2cfdd452&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfdd452",
  null
  
)

export default component.exports